import { Component, Renderer2 } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { CoreService } from '../../../../services'
import { Supplier } from 'depoto-core/src/entities'
import { Emittable, Emitter } from '@ngxs-labs/emitter'
import { PlugplayState } from '../../states/plugplay-state.service'

@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html',
  styleUrls: ['./step4.component.scss'],
})
export class Step4Component {
  @Emitter(PlugplayState.setActive)
  private readonly setActive: Emittable<number>
  @Emitter(PlugplayState.setHighestLastStepCompleted)
  public readonly setHighestLastStepCompleted: Emittable<number>
  @Emitter(PlugplayState.setHighestStepVisited)
  private readonly setHighestStepVisited: Emittable<number>
  public readonly suppliersGroup: FormGroup = new FormGroup<any>({})
  private instanceCount = 0
  public supplierMap = new Map<number, any>()

  constructor(private readonly core: CoreService) {
    this.setActive.emit(3)
    this.setHighestStepVisited.emit(3)

    this.load()
  }

  private load(): Promise<any> {
    return this.core.services.supplier
      .getList({ page: 0, sort: 'id', direction: 'DESC' }, { id: null, name: null, deletable: null, externalId: null })
      .then(response => {
        this.supplierMap = new Map((response?.items || []).map(i => [i.id, i]))
        response?.items?.forEach(item => this.suppliersGroup.addControl(item.id, new FormControl(item.name)))
        this.addItem(this.suppliersGroup)
      })
  }

  public save(id: string): void {
    if (this.suppliersGroup.get(id).value) {
      if (id.includes('new-')) {
        this.core.services.supplier.create(new Supplier({ name: this.suppliersGroup.get(id).value })).then(() => {
          this.load().then(() => this.suppliersGroup.removeControl(id))
        })
      } else {
        this.core.services.supplier.update(
          new Supplier({
            id: id,
            name: this.suppliersGroup.get(id).value,
            externalId: this.supplierMap.get(Number(id)).externalId,
          }),
        )
      }
    }
  }

  public addItem(formGroup: FormGroup): void {
    this.instanceCount++
    const groupLength = Object.keys(formGroup.controls).length
    const doesTheLastItemHaveValue = formGroup.get(Object.keys(formGroup.controls)[groupLength - 1]).value
    if (doesTheLastItemHaveValue) {
      formGroup.addControl('new-' + this.instanceCount, new FormControl({ value: '', disabled: true }))
    }
  }

  private delete(id: string): void {
    if (id.includes('new')) {
      this.suppliersGroup.removeControl(id)
    } else {
      this.core.services.supplier.delete(new Supplier({ id }))
      this.suppliersGroup.removeControl(id)
    }
  }

  public deleteDialog(id): void {
    this.delete(id)
  }

  trackById(index: number, item: { key: string; value: any }) {
    return item.key
  }

  order(a: { key }, b: { key }): number {
    return 0
  }
}
